/**
 * @fileoverview Doctor Profile Page
 * @description Profile management page for doctor role
 * @author MCHD Room Scheduler Team
 * @created 07-10-2025
 * @complies @hospital-domain.mdc - Read-only email, no password reset
 */

import { Container, Title, Text, Stack } from '@mantine/core';
import { DoctorProfileForm } from '../../features/doctor/profile/DoctorProfileForm';

/**
 * Doctor Profile Page Component
 * @description Profile management with security restrictions
 * 
 * @example
 * Route: /doctor/profile
 * Access: Doctors only (requireDoctor middleware)
 * 
 * Features:
 * - Editable: name, specialty, department
 * - Read-only: email (per @hospital-domain.mdc)
 * - No password reset (per @hospital-domain.mdc security policy)
 * - Account status display
 * - Last login timestamp
 * - Form validation with Mantine useForm
 * - Optimistic updates
 */
export default function DoctorProfilePage() {
  return (
    <Container size="md" py="xl">
      <Stack gap="xl">
        {/* Page Header */}
        <div>
          <Title order={1} mb="xs">
            My Profile
          </Title>
          <Text c="dimmed" size="sm">
            Manage your personal information and settings
          </Text>
        </div>

        {/* Profile Form */}
        <DoctorProfileForm />

        {/* Security Notice */}
        <Text size="xs" c="dimmed" ta="center" maw={600} mx="auto">
          Your profile information is protected under hospital security policies. 
          For email changes or password resets, please contact your system administrator.
        </Text>
      </Stack>
    </Container>
  );
}

